import { CommonModule, Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval, Subscription, timer } from 'rxjs';
import { FormatTimePipe } from 'src/app/helpers/pipe/format-time.pipe';
import { DashboardService } from 'src/app/services/dashboard.service';
import { OtpService } from 'src/app/services/otp.service';
import { UserService } from 'src/app/services/user.service';
import { FramerService } from 'src/app/services/framer.service';
import { OnboardingDashBoardService } from 'src/app/services/onboardingDashBoardService';
import { OAuthService } from 'angular-oauth2-oidc';
import { CookieService } from 'ngx-cookie-service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-framer-otp-screen',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FormatTimePipe],
  templateUrl: './framer-otp-screen.component.html',
  styleUrl: './framer-otp-screen.component.css'
})
export class FramerOtpScreenComponent implements OnInit {
  maskedPhoneNumber: string = '123 456 7890';
  otpErrorMsg = "";
  successMsg = "";
  successMsgWithPipe: boolean = false;
  counter: number = 0;
  tick = 1000;
  hideResendOTPButton: boolean = false;
  secondsLeft: number = 0;
  disableOTPSendButton: boolean = false;
  @ViewChildren("otpInput") otpInputs!: QueryList<ElementRef>;
  otpControls: FormControl[] = [];

  otpForm: FormGroup;
  usedOtpType!: string | number;
  otpPopupHeaderText: string = 'Get your One-Time Pin (OTP) via SMS';
  btnOTPIsDisabled: boolean = false;
  isOtpSent: boolean = false;
  resendAvailable: boolean = false;
  sendOtpText: string = 'Send SMS OTP';
  otpSession10MinInterval!: ReturnType<typeof setTimeout>;
  isNumberSubSubscribed: boolean = false;
  numbersubs!: Subscription;
  countDown: number = 30;
  isSessionTimeOutSubscribed: boolean = false;
  sessionTimeOut!: Subscription;
  isOtpScreen: boolean = false;
  optSessionStillValid: boolean = false;
  otpSessionTimeOutInterval!: ReturnType<typeof setTimeout>;
  otp: string = "";
  basicInfoVerifyConfirmed: boolean = false;
  isRestrictedUser: boolean = false;
  PhoneNumber: string = "";

  constructor(
    private otpService: OtpService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private location: Location,
    private router: Router,
    private userService: UserService,
    private dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    private framerService: FramerService,
    private onboardingDashBoardService: OnboardingDashBoardService,
    private cookieService: CookieService,
    private oauthService: OAuthService,
    private tokenService: TokenService
  ) {

    this.otpForm = this.formBuilder.group({
      Otp: ['', [Validators.required, Validators.minLength(6)]],
    });
  }


  ngOnInit() {
   
      localStorage.setItem('IsFromOtpScreen', 'true');
      sessionStorage.setItem('IsFramerFlow', 'true'); 
   
    this.activatedRoute.queryParams.subscribe({
      next: params => {
        if (params && params.vid) {
          let payload = {
            vid: params.vid
          };
          localStorage.setItem('vid', params.vid);
          this.framerService.GetToken(payload).subscribe({
            next: (data: any) => {
              sessionStorage.setItem('IsFramerFlow', 'true');
              console.log('Token received:', data.token);
              localStorage.setItem('tempToken', data.token);
              this.PhoneNumber = data.phoneNumber;
              if (this.PhoneNumber == null || this.PhoneNumber == undefined || this.PhoneNumber == '') {
                this.router.navigate(['/register']);
              }
              this.validateUserBasicInfoWithBureau();
              this.sendOtp(1);
            },
            error: (error: any) => {
              this.router.navigate(['/register']);
            }
          });
        }
        else {
          this.router.navigate(['/register']);
        }
      }
    });


  }

  // go back button functionality
  goBack() {
    if (window.history.length > 1) {
      this.location.back();   // goes back in browser/mobile history
    } else {
      this.router.navigate(['/register']); // fallback route
    }
  }



  // send otp functionality
  sendOtp(otpType: string | number) {
    console.log('sendOtp called with type:', otpType);
    this.successMsg = "";
    if (this.PhoneNumber) {
      this.maskedNumber(this.PhoneNumber.slice(-4));
    }
    this.otpErrorMsg = '';
    // for (let i = 1; i <= 6; i++) {
    //   const otpInput = document.getElementById('otp' + i) as HTMLInputElement;
    //   otpInput.classList.remove('border-error');
    //   otpInput.value = '';
    // }
    const param = {
      OtpType: otpType,
    };

    this.usedOtpType = otpType;
    console.log('sendOtp called with type:', otpType);

    this.otpService.sendOtps(param).subscribe({
      next: (data: any) => {
        this.otpPopupHeaderText = 'Your OTP has been sent to you, please enter it below';
        this.btnOTPIsDisabled = false;
        this.isOtpSent = true;

        if (data.sendOtpStatusType.status === 200) {


          if (data.sendOtpStatusType.message === "SecondOTPSent") {
            this.hideResendOTPButton = true;
            this.resendAvailable = false;
            this.sendOtpText = 'Resend SMS OTP';
          }
          if (data.sendOtpStatusType.message === "Sent") {
            this.hideResendOTPButton = false;
            this.resendAvailable = true;
            this.successMsg = '';
            this.disableOTPSendButton = true;
            this.sendOtpText = '';
            if (this.otpSession10MinInterval != undefined) {
              clearTimeout(this.otpSession10MinInterval);
            }
            if (this.isNumberSubSubscribed) {
              this.secondsLeft = 0;
              this.numbersubs.unsubscribe();
            }

            if (this.isNumberSubSubscribed) {
              this.numbersubs.unsubscribe();
            }

            this.disableOTPSendButton = true;
            let numbers = interval(1000);
            this.numbersubs = numbers.subscribe({
              next: x => {
                this.isNumberSubSubscribed = true;
                this.secondsLeft = this.countDown - x;
                if (this.secondsLeft == 0) {
                  this.numbersubs.unsubscribe();
                  this.isNumberSubSubscribed = false;
                  this.disableOTPSendButton = false;
                }
              }
            });
          }
          this.otpSession10MinInterval = setTimeout(() => {
            this.successMsgWithPipe = false;

            if (this.isSessionTimeOutSubscribed) {
              this.sessionTimeOut.unsubscribe();
            }

            setTimeout(() => {
              window.location.reload();
            }, 5000);
            this.otpErrorMsg = 'OTP session has expired, please try again.'

          }, 600000);
        }

        if (this.sendOtpText === 'Resend SMS OTP') {
          this.successMsg = 'OTP resent successfully.';
          this.disableOTPSendButton = true;
          this.hideResendOTPButton = true;
          // setTimeout(() => {
          //   this.successMsg = '';
          // }, 3000);


        }



        if (data.sendOtpStatusType.status === 202) {
          this.otpErrorMsg = 'OTP already verified, please try later.';
        }

        if (!this.isOtpScreen) {
          this.isOtpScreen = true;
          this.spinner.hide();
        }
        // $('#id-number-form')[0].style.setProperty('display', 'none', 'important');
        // $('#registerForm').hide();
      },
      error: (err: HttpErrorResponse) => {
        if (err.error.sendOtpStatusType.status === 421) {
          if (err.error.sendOtpStatusType.sessionTimeOut > 0) {
            if (!this.isOtpScreen) {
              this.isOtpScreen = true;
              this.spinner.hide();
            }
            // $('#id-number-form')[0].style.setProperty('display', 'none', 'important');
            // $('#registerForm').hide();
            this.sendOtpText = "Resend SMS OTP";
            this.isOtpSent = true;
            if (this.resendAvailable) {
              this.sendOtpText = 'Resend SMS OTP';
              this.hideResendOTPButton = false;
            }
            else {
              this.hideResendOTPButton = true;
              this.optSessionStillValid = true;

              this.successMsg = "An OTP has already been sent to your cellphone number."

              this.otpSessionTimeOutInterval = setTimeout(() => {
                this.counter = err.error.sendOtpStatusType.sessionTimeOut;
                this.sessionTimeOut = timer(0, this.tick).
                  subscribe({
                    next: () => {
                      --this.counter;
                      this.isSessionTimeOutSubscribed = true;


                      if (this.counter === 0) {
                        this.sessionTimeOut.unsubscribe();
                        this.isSessionTimeOutSubscribed = false;
                        window.location.reload();
                      }
                    }
                  });

                this.successMsgWithPipe = true;
                this.successMsg = '';

              }, 3000);
            }
          }
          else {
            this.otpErrorMsg = "OTP Already Sent. Please try after later";
          }
        }
        else if (err.error.sendOtpStatusType.status === 429) {
          this.otpErrorMsg = 'OTP failed, please try again.';
        }
        else {
          this.otpErrorMsg = 'Please contact admin';
        }
      }
    });

  }

  // validate otp functionality
  validateOtp(otpValue: string) {
    const payload = {
      Otp: parseInt(otpValue),
      OtpType: this.usedOtpType
    };

    console.log('Validating OTP with payload:', payload);


    this.otpService.validateOtps(payload).subscribe({
      next: (data: any) => {
        setTimeout(() => {
          this.resetOtpToDefault();
          // now check if verify ok and otp ok no need for open security question
          this.checkSecurityQuestionsNeeded();
        }, 500);
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 422) {
          this.otpErrorMsg = 'The OTP you entered is incorrect. Please try again.';
          this.successMsg = '';
          if (this.isSessionTimeOutSubscribed) {
            setTimeout(() => {
              this.otpErrorMsg = '';
            }, 3000);

          }
          for (let i = 1; i <= 6; i++) {
            const otpInput = document.getElementById('txt_registration_OTP' + i) as HTMLInputElement;
            otpInput.classList.add('border-error');
            otpInput.value = '';
          }

          this.otpForm.markAllAsTouched();

        }
        else if (err.status === 403) {
          this.otpErrorMsg = "OTP session has expired, please try later."
          this.otpForm.reset();
          this.disableOtpInputs();
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          this.otpErrorMsg = 'Please contact admin';
        }
      }
    });


    console.log('Validating OTP with value:', otpValue);
  }

  maskedNumber(phoneNumber: string | number) {
    this.maskedPhoneNumber = '*** *** ' + phoneNumber;
    console.log('Masked phone number set to:', this.maskedPhoneNumber);
  }
  resetOtpToDefault() {

    if (this.otpSession10MinInterval != undefined) {
      clearTimeout(this.otpSession10MinInterval);
    }
    if (this.otpSessionTimeOutInterval != undefined) {
      clearTimeout(this.otpSessionTimeOutInterval);
    }
    if (this.isSessionTimeOutSubscribed) {
      this.sessionTimeOut.unsubscribe();
    }

    this.successMsgWithPipe = false;
    this.optSessionStillValid = false;
  }
  checkSecurityQuestionsNeeded() {
    if (this.basicInfoVerifyConfirmed === false) {
      localStorage.removeItem('OnLoadCheck');
      // now check if restricted user no need for open security question
      if (this.isRestrictedUser == false) {
        this.openSecurityQuestions();
      }

    } else {
      this.login();
    }

  }
  openSecurityQuestions() {
    this.router.navigate(['/security-question']);


  }
  login() {
    this.spinner.show();
    this.onboardingDashBoardService.GetSeamLessLogin().subscribe({
      next: (data: any) => {
        if (data !== null) {
          this.handleLoginSuccess(data);
        } else {
          this.spinner.show();
          this.azureAdLogin();
        }
      }, error: (err: HttpErrorResponse) => {
        this.spinner.show();
        this.azureAdLogin();
      }
    });
  }
  azureAdLogin() {
    localStorage.removeItem('tempToken');
    let submissionId = '';
    if (sessionStorage.getItem('submissionId')) {
      submissionId = sessionStorage.getItem('submissionId') ?? '';
    }

    let trackingVisitorId = this.cookieService.get('visitorId');
    let trackingSessionId = sessionStorage.getItem('sessionId');
    console.log('trackingVisitorId', trackingVisitorId);
    console.log('trackingSessionId', trackingSessionId);
    this.oauthService.initLoginFlow('', {
      submissionId, ccAppUrl: window.location.origin
    });
  }
  handleLoginSuccess(data: any) {
    try {
      localStorage.setItem('apiUserModel', JSON.stringify(data.apiUserModel));

      const decodedToken = atob(data.tokenString);
      this.tokenService.setAuthToken(decodedToken);
      localStorage.removeItem('tempToken');


      let vid = localStorage.getItem('vid');
      let payload = {
        vid: vid
      };
      this.framerService.UpdateVisitId(payload).subscribe({
        next: (data: any) => {
          localStorage.removeItem('vid');
        },
        error: (error: any) => {
          this.router.navigate(['/register']);
        }
      });

      let submissionId = '';
      if (sessionStorage.getItem('submissionId')) {
        submissionId = sessionStorage.getItem('submissionId') ?? '';
      }

      window.location.href = '/welcome';
    } catch {
      console.error('Failed to decode token or store apiUserModel');
      this.spinner.show();
      this.azureAdLogin();
    }

  }


  onKeyUpEvent(event: any, index: number) {
    const eventCode = event.which || event.keyCode;
    if (event.target.value.length === 1) {
      if (index !== 6) {
        if (eventCode === 37 && index != 1) {
          this.getOtpElement(index - 1).focus();
        }
        else if (eventCode === 37 && index == 1) {
          this.getOtpElement(index).focus();
        }
        else if (eventCode === 9) {
          this.getOtpElement(index).focus();
        }
        else {
          this.getOtpElement(index + 1).focus();
        }
      } else {
        this.getOtpElement(index).blur();
        this.otp =
          this.getOtpElement(1).value +
          this.getOtpElement(2).value +
          this.getOtpElement(3).value +
          this.getOtpElement(4).value +
          this.getOtpElement(5).value +
          this.getOtpElement(6).value;

        this.validateOtp(this.otp);
      }
    } else if (event.target.value.length > 1) {
      this.getOtpElement(index).value = '';
    }
    if ((eventCode === 8 || eventCode === 37) && index !== 1) {
      this.getOtpElement(index - 1).focus();
    }
  }

  getOtpElement(index: number) {
    return <HTMLInputElement>document.getElementById('txt_registration_OTP' + index);
  }



  onFocusEvent(index: number) {
    for (let item = 1; item < index; item++) {
      const currentElement = this.getOtpElement(item);
      if (!currentElement.value) {
        currentElement.focus();
        break;
      }
    }
  }

  disableOtpInputs() {
    for (let i = 1; i <= 6; i++) {
      const otpInput = document.getElementById('txt_registration_OTP' + i) as HTMLInputElement;
      if (otpInput) {
        otpInput.disabled = true;
        otpInput.classList.add('border-error'); // Optional: visually indicate disabled/error
      }
    }
    this.otpForm.disable(); // Also disables the form group for extra safety
  }


  validateUserBasicInfoWithBureau() {
    this.otpErrorMsg = '';
    this.basicInfoVerifyConfirmed = false;
    this.userService.validateUserBasicInfoWithBureau().subscribe({
      next: (data: any) => {
        console.log('Bureau validation response:', data);
        if (data.isVerify === true) {
          this.basicInfoVerifyConfirmed = true;
          this.isRestrictedUser = false;
        } else {
          this.basicInfoVerifyConfirmed = false;
          this.isRestrictedUser = data.isRestrictedUser;
        }
      },
      error: (err: HttpErrorResponse) => {
      }
    });
  }

  InsertUtmSource() {
    var isUtmAvailable = false;
    var payload;

    if (localStorage.getItem('UtmParams') !== null) {
      isUtmAvailable = true;
      payload = {
        WebSource: '',
        UtmParams: localStorage.getItem('UtmParams'),

      }
    }
    else if (localStorage.getItem('query_params') !== null) {
      isUtmAvailable = true;
      payload = {
        WebSource: '',
        UtmParams: localStorage.getItem('query_params'),

      }
    }

    if (isUtmAvailable) {
      this.dashboardService.InsertUtmTracking(payload).subscribe({
        next: () => {
          setTimeout(() => localStorage.removeItem('UtmParams'), 300);
          setTimeout(() => localStorage.removeItem('query_params'), 300);
        }
      });
    }
  }


}

